export default "__VITE_ASSET__DQ7SWp7$__"